import type {AxisDataService} from "../types/axis-data-service.interface";
import {AxisDataServiceConfiguration} from "../types/axis-data-service-configuration.interface";
import {AxisDataProviderFactoryInterface} from "../types/axis-data-provider-factory.interface";

/**
 * Factory class responsible for creating instances of AxisDataService based on the provided configuration.
 *
 * This class implements the AxisDataProviderFactoryInterface to ensure compliance with the contract
 * for creating axis data service instances.
 *
 * @template TValue - The type of value handled by the axis data service.
 */
export class AxisDataProviderFactory<TValue> implements AxisDataProviderFactoryInterface<TValue> {

    /**
     * Creates an instance of AxisDataService using the provided configuration.
     *
     * @param {AxisDataServiceConfiguration<TValue>} axisDataServiceConfiguration - The configuration object containing the type, dataServiceId, and options required to construct the AxisDataService.
     * @return {AxisDataService<TValue>} A new instance of AxisDataService constructed using the specified configuration.
     */
    create(axisDataServiceConfiguration: AxisDataServiceConfiguration<TValue>): AxisDataService<TValue> {
        console.log(`[AxisFactory] create() called for: ${axisDataServiceConfiguration.dataServiceId}`);
        const AxisDataServiceConstructor = axisDataServiceConfiguration.type;

        return new AxisDataServiceConstructor(
            axisDataServiceConfiguration.dataServiceId,
            axisDataServiceConfiguration.options
        );
    }

}